import getMatomoConfig from 'beisheim/utils/get-matomo-config'

const externalScripts = {
  methods: {
    getExternalScripts() {
      const script = []
      const link = []

      // include polyfills for IE11 or lower
      const isIE11OrLower = process.browser && (navigator.userAgent.includes('MSIE') || navigator.appVersion.includes('Trident/'))
      if (isIE11OrLower) {
        script.push({ src: 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.js' })
      }

      if (!this.$cms) {
        if (process.env.COOKIEBOT_ID) {
          script.push({
            id: 'Cookiebot',
            src: 'https://consent.cookiebot.com/uc.js',
            'data-cbid': process.env.COOKIEBOT_ID,
            'data-blockingmode': 'auto',
            type: 'text/javascript'
          })
        }

        const matomoConfig = getMatomoConfig(this.$route);

        if (matomoConfig.isAllowed && process.server) {
          script.push({
            src: '/matomo.js',
            'data-url': matomoConfig.url,
            'data-site': matomoConfig.siteId,
            type: 'text/javascript',
            body: true
          })
        }
      }

      return {
        link,
        script
      }
    }
  }
}

export default externalScripts
